import { CIcon } from '~/icons/types'

export const ciHeading1: CIcon = {
  width: '24',
  height: '24',
  paths: [
    {
      d:
        'M12 4.5A1.5 1.5 0 0 0 10.5 6v4.5h-5V6a1.5 1.5 0 1 0-3 0v12a1.5 1.5 0 1 0 3 0v-4.5h5V18a1.5 1.5 0 1 0 3 0V6A1.5 1.5 0 0 0 12 4.5Zm8.708 4.177a1.5 1.5 0 0 0-1.54.075l-3 2a1.5 1.5 0 1 0 1.664 2.496l.668-.445V18a1.5 1.5 0 0 0 3 0v-8c0-.553-.305-1.062-.792-1.323Z'
    }
  ],
  ellipses: [],
  circles: [],
  name: 'heading-1',
  type: 'solid'
}
